// extracted by mini-css-extract-plugin
export default {"container":"switch_container__TqEQY","input":"switch_input__Vnzl3","label":"switch_label__BTL3E"};